import React from 'react'
import Chart from "react-apexcharts"

export default function ActiveLogins(props) {

    const { graph } = props

    const month = graph && graph.filter((o, i) => i !== 0).map(value => value.month)
    const count = graph && graph.filter((o, i) => i !== 0).map(value => value.user_count)

    var series = [{
        name: 'Login',
        data: count ? count : []
    },
        // {
        //     name: 'series2',
        //     data: [11, 32, 45, 32, 34, 52, 41]
        // }
    ]

    var options = {
        chart: {
            // height: 350,
            type: 'area',

            toolbar: {
                show: false
            },

            zoom: {
                enabled: false
            }
        },
        dataLabels: {
            enabled: false
        },
        stroke: {
            curve: 'smooth'
        },
        xaxis: {
            // type: 'area',
            categories: month ? month : []
            // categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
        },
        tooltip: {
            x: {
                format: 'dd/MM/yy HH:mm'
            },
        },
    }

    return (
        <div>
            <Chart options={options} series={series} type="area" height='auto' width='100%' />
        </div>
    )
}
